import { useState } from "react";
import { Search, ChevronRight } from "lucide-react";
import { Input } from "../ui/input";
import { cn } from "../../lib/utils";

export function Sidebar({ activeCategory, onCategoryChange, categories }) {
  const [search, setSearch] = useState("");

  // filter categories based on search
  const filteredCategories = categories.filter((category) =>
    category.CategoryName.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="w-64 bg-background border-r border-border h-full flex flex-col">
      {/* Header */}
      <div className="p-4 border-b border-border">
        {/* Search */}
        <div className="relative">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
          <Input
            type="text"
            placeholder="Search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="pl-10 bg-background border-border"
          />
        </div>
      </div>

      {/* Menu Categories */}
      <div className="flex-1 overflow-y-auto">
        {filteredCategories.map((category) => (
          <button
            key={category.CategoryId}
            onClick={() => onCategoryChange(category.CategoryId.toString())}
            className={cn(
              "w-full px-4 py-3 text-left flex items-center justify-between border-b border-border transition-colors",
              "hover:bg-muted",
              activeCategory === category.CategoryId.toString() &&
              "bg-primary text-primary-foreground hover:bg-primary"
            )}
          >
            <span className="text-sm font-medium">{category.CategoryName}</span>
            {activeCategory === category.CategoryId.toString() && (
              <ChevronRight className="h-4 w-4" />
            )}
          </button>
        ))}

        {/* No results case */}
        {filteredCategories.length === 0 && (
          <p className="p-4 text-sm text-muted-foreground">No categories found</p>
        )}
      </div>
    </div>
  );
}
